<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chap-title1" id="C3">Equipment</h1>
<p class="intro1">If you’ve found that designing cakes has become a bit of a passion, you will no doubt have accumulated a basic toolkit of equipment. These pages show what I use most often. I’ve divided the items up into categories, so you can see what is needed for each stage.</p>
<h5 class="subhead5">A. FOR LAYERING, FILLING AND MASKING CAKES FOR A SHARP EDGE FINISH</h5>
<ol>
<li>Serrated knife</li>
<li>Offset spatula</li>
<li>Paring knife</li>
<li>Flat scraper with long blade</li>
<li>Right-angled scraper or ruler</li>
<li>Simple syrup, flavoured with liquor</li>
<li>Ruler with millimetres (or <sup class="num">1</sup>⁄<sub class="den">16</sub>s of an inch)</li>
<li>Flat palette knife</li>
<li>Pastry brush</li>
<li>Working board or food board</li>
<li>Rigid cake boards such as silver-covered masonite</li>
<li>Non-slip mat</li>
</ol>
<p class="image-center"><img alt="" src="images/P9-1.jpg"/></p>
<h5 class="subhead5">B. FOR FONDANT COVERING</h5>
<p class="para-list">13. Rolling pin</p>
<p class="para-list">14. Modelling tool such as soft blade or tapered end</p>
<p class="para-list">15. Paring knife</p>
<p class="para-list">16. Straight edged smoothers</p>
<p class="para-list">17. Cornflour (cornstarch)</p>
<p class="para-list">18. Non-slip mat</p>
<p class="para-list">19. Acupuncture needles</p>
<p class="para-list">20. Jam (jelly) syrup</p>
<p class="para-list">21. Acetate buffers</p>
<p class="image-center"><img alt="" src="images/P9-2.jpg"/></p>
<h5 class="subhead5">C. FOR DECORATING</h5>
<p class="para-list">22. Silicone moulds</p>
<p class="para-list">23. Culinary stencil</p>
<p class="para-list">24. Pasta machine</p>
<p class="para-list">25. Cake decorator’s alcohol (95% ethanol)</p>
<p class="para-list">26. Scissors</p>
<p class="para-list">27. Design knife or scalpel</p>
<p class="para-list">28. Tweezers</p>
<p class="para-list">29. Edible glaze spray</p>
<p class="para-list">30. Tissues</p>
<p class="para-list">31. Artist’s paintbrushes, different sizes</p>
<p class="para-list">32. Edible pen</p>
<p class="para-list">33. Hot glue gun</p>
<p class="para-list">34. Pastry brushes</p>
<p class="para-list">35. Edible marker</p>
<p class="image-center"><img alt="" src="images/P9-3.jpg"/></p>
<h5 class="subhead5">D. FOR FLOWER MAKING</h5>
<p class="para-list">36. Florist’s wires</p>
<p class="para-list">37. Florist’s tape, Parafilm (plastic) and Floratape (crepe)</p>
<p class="para-list">38. Cornflour (cornstarch)</p>
<p class="para-list">39. Petal pad</p>
<p class="para-list">40. Sugar glue</p>
<p class="para-list">41. Foam balls</p>
<p class="para-list">42. Silicone moulds for flower centres</p>
<p class="para-list">43. Petal and leaf impression mats</p>
<p class="para-list">44. Petal dusts</p>
<p class="para-list">45. Cutters including flower, leaf and circles</p>
<p class="para-list">46. Frilling tool</p>
<p class="para-list">47. Paintbrushes and fluffy dusting brushes</p>
<p class="para-list">48. Balling tool</p>
<p class="para-list">49. Paring knife</p>
<p class="para-list">50. Small rolling pin</p>
<p class="image-center"><img alt="" src="images/P9-4.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter3.vue?23b52d60